import { BookOpen, Home, Settings, Sparkles } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigation } from "../contexts/NavigationContext";

interface NavItem {
    id: string;
    label: string;
    navigate: () => void;
    icon: React.ComponentType<{ className?: string }>;
    authRequired?: boolean;
    isActive: (currentPath: string) => boolean;
}

export function BottomNavigation() {
    const { user } = useAuth();
    const { navigateToHome, navigateToStoryMode, navigateToMyStories, navigateToSettings, currentPath, isOnAuthPage } =
        useNavigation();

    // Don't show bottom nav on auth pages
    if (isOnAuthPage) {
        return null;
    }

    const navItems: NavItem[] = [
        {
            id: "home",
            label: "Home",
            navigate: navigateToHome,
            icon: Home,
            isActive: (path) => path === "/",
        },
        {
            id: "story-mode",
            label: "Create",
            navigate: navigateToStoryMode,
            icon: Sparkles,
            authRequired: true,
            isActive: (path) => path === "/story-mode",
        },
        {
            id: "my-stories",
            label: "My Stories",
            navigate: navigateToMyStories,
            icon: BookOpen,
            authRequired: true,
            isActive: (path) => path === "/my-stories",
        },
        {
            id: "account",
            label: "Settings",
            navigate: navigateToSettings,
            icon: Settings,
            authRequired: true,
            isActive: (path) => path === "/settings",
        },
    ];

    // Filter nav items based on auth status
    const visibleNavItems = navItems.filter((item) => !item.authRequired || user);

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 page-gradient border-t border-border z-50 pb-[env(safe-area-inset-bottom)]">
            <div className="flex items-center justify-around px-2 py-2">
                {visibleNavItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = item.isActive(currentPath);

                    return (
                        <button
                            key={item.id}
                            onClick={item.navigate}
                            className={`flex flex-col items-center justify-center min-h-[3rem] px-3 py-1 rounded-lg transition-colors ${
                                isActive
                                    ? "text-primary bg-primary/10 font-semibold"
                                    : "text-muted-foreground hover:text-primary  hover:bg-primary/5"
                            }`}
                        >
                            <Icon className="h-5 w-5 mb-1" />
                            <span className="text-xs font-medium truncate max-w-[4rem]">{item.label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
